import React from 'react';
import '../styling/gameDisplayPage.css';
import NavBar from '../components/navBar';
import IndividualGameTile from '../components/IndividualGameTile';
import SideBar from '../components/sidebar';
import FollowersGame from '../components/FollowersGame';
import {getGameData} from '../components/utilities'
import { UserContext } from '../contexts/UserContext'


export default class GameDisplayPage extends React.Component{

	constructor(props) {
		super(props);
	}

	static context = UserContext;
	//currentGame can be:
	// - "followers_game"
	// - "guess_who_tweeted_game"
	state = {
		data: this.props.data,
		currentGame: "followers_game"
	}

	

   	render = () => {
        return(
            <div className="GameDisplay">
                <NavBar/>
                <SideBar/>
				{this.state.currentGame == "followers_game" ? <FollowersGame/> : <> Other game! </>}
                
			</div>
        );
    }
}